import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {CircularProgress, FormLabel} from '@mui/material';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';

import Alert, { useAlert } from 'components/snacks/Alert';

import { numSeperator } from 'utils/DataBase';
import { checkDiscountCode, axiosInstance, getFactorDetail } from 'api/Api';
import Typography from "@mui/material/Typography";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import LoadingButton from "components/button/LoadingButton";

const FactorPayment = () => {
  const { factorId } = useParams();
  // const [validList, setValidList] = useState([
  //   { validity_id: null, title: null, price: 0 }
  // ]);
  const [product, setProduct] = useState([
    { product_id: null, title: null, cat_id: null }
  ]);
  const [sum, setSum] = useState(0);
  // If paymentMethod = 3 -> کیف پول
  // If paymentMethod = 0 -> درگاه پرداخت
  // If paymentMethod = 1 -> کارت به کارت
  const [paymentMethod, setPaymentMethod] = useState(1);

  const [showDiscountItem, setShowDiscountItem] = useState(false);
  const [discountAmount, setDiscountAmount] = useState();

  const [code, setCode] = useState('');
  const [factorData, setFactorData] = useState(null);
  const [codeData, setCodeData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [card, setCard] = useState(false);
  const [showMainMessage, setShowMainMessage] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [userInfo, setUserInfo] = useState({ customer_type: 0 });
  const [loadingBtn, setLoadingBtn] = useState(false) // For loading button

  const alert_timeout = 10000;
  const alertStore = useAlert(alert_timeout);

  const payment = () => {
    const formData = new FormData();
    setIsPayment(true)
    formData.append('invoice_id', factorId);
    formData.append('code', code);
    if (paymentMethod === 0){
      formData.append('payment_type', 0);
      setLoadingBtn(true)
      axiosInstance()
          .post('/online-payment', formData)
          .then((r) => {
            if (r.data.status === 200) {
              setIsPayment(false)
              setTimeout(()=>{
                setLoadingBtn(false)
                return window.location.replace(r.data.url);
              }, 1000)
            } else {
              alertStore.AddAlert({
                key: '400',
                message: r.data.msg,
                severity: 'error',
                auto_hide: true
              });
              setIsPayment(false)
              setTimeout(()=>{
                setLoadingBtn(false)
              }, 1000)
            }
          });
    }else if (paymentMethod === 3){
      setLoadingBtn(true)
      formData.append('payment_type', 3);
      axiosInstance()
          .post('/online-payment', formData)
          .then((r) => {
            if (r.data.status === 200) {
              setIsPayment(false)
              setTimeout(()=>{
                setLoadingBtn(false)
                return window.location.replace(r.data.url);
              }, 1000)
            } else {
              alertStore.AddAlert({
                key: '400',
                message: r.data.msg,
                severity: 'error',
                auto_hide: true
              });
              setIsPayment(false)
              setTimeout(()=>{
                setLoadingBtn(false)
              }, 1000)
            }
          });
    }
  };

  useEffect(() => {
    setPaymentMethod(factorData?.factor_info?.wallet_remain > 0 ? 3 : (factorData?.factor_info?.payment_method !== 1 ? 0 : 1))
    let sum_store = JSON.parse(localStorage.getItem('sum'));
    setLoading(true);
    getFactorDetail(factorId, (res, data) => {
      setLoading(false);
      if (res) {
        setFactorData(data);
        setCard(true);
      }
    });

    if (card) {
      setSum(sum_store);
    }
    try {
      setUserInfo(JSON.parse(localStorage.getItem('user_info')));
    } catch (e) {
      console.log(e);
    }
  }, [card]);

  const checkDiscount = () => {
    const serviceId = factorData?.factor_info?.service_id;
    if (code) {
      setLoading(true);
      checkDiscountCode(
          code,
          serviceId,
          factorData?.factor_info?.factor_price,
          (isOk, data) => {
            if (isOk) {
              setCodeData({
                discount_price: data.discount_price,
                price: parseFloat(data.price),
                tax_value: parseFloat(data.tax_value)
              } );
              let n = {...factorData}
              n.factor_info.total_payment = parseFloat(data.price);
              setFactorData(n)
              alertStore.AddAlert({
                key: '400',
                message: data.msg,
                severity: 'success',
                auto_hide: true
              });
              setShowDiscountItem(true);
              setDiscountAmount(parseFloat(data.discount_price))
            } else {
              alertStore.AddAlert({
                key: '400',
                message: data.msg,
                severity: 'error',
                auto_hide: true
              });
            }
            setLoading(false);
          }
      );
    } else {
      alertStore.AddAlert({
        key: '400',
        message: 'کد تخفیف موجود نیست!',
        severity: 'error',
        auto_hide: true
      });
    }
  };
  return (
    <>
      {showMainMessage ? (
        <>
          <div className="d-flex flex-column justify-content-center align-items-center min-h-80">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="250"
              height="250"
              fill="#47BE7D"
              className="bi bi-check2-circle"
              viewBox="0 0 16 16"
            >
              <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
              <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
            </svg>
            <h5 className={'mt-5'} id={'response_message_card_detail'}></h5>
            <div className="d-flex mt-5">
              <Link to={'/'} className={'btn btn-secondary'}>
                داشبورد
              </Link>
              <Link to={'/factors'} className={'btn btn-info ms-5'}>
                لیست فاکتور ها
              </Link>
            </div>
          </div>
        </>
      ) : (
        <>
          {loading ? (
            <div
              className={
                'min-h-80 d-flex justify-content-center align-items-center'
              }
            >
              <div
                className={
                  'd-flex justify-content-start align-items-center ms-5'
                }
              >
                <h1>در حال بارگذاری...</h1>
                <Box sx={{ display: 'flex', marginRight: '20px' }}>
                  <CircularProgress />
                </Box>
              </div>
            </div>
          ) : (
            <>
              {card ? (
                  <div className="row mt-3">
                    <div className="col-12 col-lg-9">
                      <div className="bg-white normal-shadow rounded-lg py-2 px-2 px-lg-10 py-lg-10">
                        <h3 className="mb-8 text-center">
                          <span className="f-13 ms-3">بررسی نهایی و پرداخت</span>
                        </h3>
                        <div className="cart_detail pb-50">

                              <div className="cart__list">
                                <div className="coupon-code">
                              <span className="f-14 d-flex flex-wrap align-items-center gap-2">
                                <Box className={`green-color`}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><g fill="none" stroke="currentColor"><path strokeWidth="1.5" d="M10.51 3.665a2 2 0 0 1 2.98 0l.7.782a2 2 0 0 0 1.601.663l1.05-.058a2 2 0 0 1 2.107 2.108l-.058 1.049a2 2 0 0 0 .663 1.6l.782.7a2 2 0 0 1 0 2.981l-.782.7a2 2 0 0 0-.663 1.601l.058 1.05a2 2 0 0 1-2.108 2.107l-1.049-.058a2 2 0 0 0-1.6.663l-.7.782a2 2 0 0 1-2.981 0l-.7-.782a2 2 0 0 0-1.601-.663l-1.05.058a2 2 0 0 1-2.107-2.108l.058-1.049a2 2 0 0 0-.663-1.6l-.782-.7a2 2 0 0 1 0-2.981l.782-.7a2 2 0 0 0 .663-1.601l-.058-1.05A2 2 0 0 1 7.16 5.053l1.049.058a2 2 0 0 0 1.6-.663z"/><path strokeLinejoin="round" strokeWidth="2.25" d="M9.5 9.5h.01v.01H9.5zm5 5h.01v.01h-.01z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m15 9l-6 6"/></g></svg>
                                </Box>
                                کد تخفیف خود را در این بخش وارد نمایید.
                              </span>
                                  <div className="coupon-input">
                                    <input
                                        type="text"
                                        name="code"
                                        id="discount_code"
                                        placeholder="کد تخفیف"
                                        style={{
                                        }}
                                        onChange={(e) => setCode(e.target.value)}
                                    />
                                    <span
                                        className="pcoupon-submit discount_check "
                                        onClick={checkDiscount}
                                    >
                                  بررسی
                                </span>
                                  </div>
                                </div>
                              </div>

                          <div
                              className="text-dark"
                          >

                            <Box className="d-flex align-items-center gap-4 my-5">
                              <Typography variant="h6">شماره فاکتور: </Typography>
                              <span>{factorData?.factor_info?.invoice_no}</span>
                            </Box>
                            <Box className="d-flex flex-column mb-5 border rounded-lg">
                              <Box className="d-flex align-items-center justify-content-between p-4">
                                <Box className="flex-1"><Typography variant="h6">سرویس</Typography></Box>
                                <Box className="flex-1">
                                  <Typography variant="h6">تاریخ فاکتور</Typography>
                                </Box>
                                <Box className="flex-1 justify-content-end d-flex">
                                  <Typography variant="h6">مبلغ فاکتور</Typography>
                                </Box>
                              </Box>
                              <Box className="d-flex align-items-center justify-content-between p-4 border-top">
                                <Box className="flex-1 text-muted">
                                  {factorData?.factor_info?.service_name}
                                </Box>
                                <Box className="flex-1 text-muted">
                                  {factorData?.factor_info?.invoice_date}
                                </Box>
                                <Box className="flex-1 text-muted justify-content-end d-flex">
                                  {factorData?.factor_info?.factor_price &&
                                      numSeperator(
                                          factorData?.factor_info?.factor_price
                                      )}
                                </Box>
                              </Box>
                            </Box>

                            <Box className="w-lg-50 border rounded-lg bg-light-gray ms-auto">
                              <div className="final-price relative p-4 d-flex justify-content-between">
                              <span className="text-muted" style={{fontSize: '13px'}}>
                                مبلغ فاکتور
                              </span>
                                <span>
                                <b style={{fontSize: '13px'}}>
                                  {factorData?.factor_info?.factor_price &&
                                      numSeperator(
                                          factorData?.factor_info?.factor_price
                                      )}
                                </b>
                                <b
                                    style={{fontSize: '13px'}}
                                    className={'ms-1'}
                                >
                                  تومان
                                </b>
                              </span>
                              </div>
                              {(showDiscountItem || factorData?.factor_info?.discount_price !==0) && (
                                  <div className="final-price relative border-top p-4 d-flex justify-content-between">
                              <span className="red-color" style={{fontSize: '13px'}}>
                                مبلغ تخفیف
                              </span>
                                    <span className={`red-color`}>
                                <b style={{fontSize: '13px'}}>
                                  {factorData?.factor_info?.discount_price !==0 ?  numSeperator(factorData?.factor_info?.discount_price) : numSeperator(
                                      discountAmount
                                  )}
                                </b>
                                <b
                                    style={{fontSize: '13px'}}
                                    className={'ms-1'}
                                >
                                  تومان
                                </b>
                              </span>
                                  </div>
                              )}
                              <div className="final-price relative border-top p-4 d-flex justify-content-between">
                              <span className="text-muted" style={{ fontSize: '13px' }}>
                                مالیات
                                <span
                                    className={
                                      'badge badge-light-success text-success f-09 ms-1'
                                    }
                                    style={{ minWidth: 'unset' }}
                                >
                                  {factorData.factor_info.is_official === 1 ? (
                                      <>10 درصد</>
                                  ) : (
                                      <>0</>
                                  )}
                                </span>
                              </span>
                                <span>
                                <b
                                    className="tax_value"
                                    style={{ fontSize: '13px' }}
                                >
                                  {factorData.factor_info.is_official !== 1 ? (
                                      <>0</>
                                  ) : (
                                      <>
                                        {!codeData
                                            ? factorData?.factor_info
                                                ?.total_payment &&
                                            numSeperator(
                                                Math.round(
                                                    factorData?.factor_info?.tax
                                                )
                                            )
                                            : numSeperator(codeData.tax_value)}
                                      </>
                                  )}
                                </b>
                                <b
                                    style={{ fontSize: '13px' }}
                                    className={'ms-1'}
                                >
                                  تومان
                                </b>
                              </span>
                              </div>
                              <div className="final-price relative border-top p-4 d-flex justify-content-between">
                                <span className="text-muted">مجموع هزینه پرداختی</span>
                                <span>
                                <b id="all_pay">
                                  {factorData.factor_info.is_official !== 1 ? (
                                      <>
                                        {numSeperator(
                                            sum +
                                            factorData?.factor_info?.total_payment
                                        )}
                                      </>
                                  ) : (
                                      <>
                                        {!codeData
                                            ? factorData?.factor_info
                                                ?.total_payment &&
                                            numSeperator(
                                                Math.round(
                                                    factorData?.factor_info
                                                        ?.total_payment
                                                )
                                            )
                                            : numSeperator(codeData.price)}
                                      </>
                                  )}
                                </b>
                                <b className={'ms-1'}>تومان</b>
                              </span>
                              </div>
                            </Box>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-lg-3">
                      <div className="bg-info normal-shadow rounded-lg py-2 px-2 px-lg-10 py-lg-4 d-flex flex-column">
                        <Box className="text-white">
                          <span>مبلغ قابل پرداخت</span>
                          <Typography variant="h4" className="text-white mt-3">
                            {factorData.factor_info.is_official !== 1 ? (
                                <>
                                  {numSeperator(
                                      sum +
                                      factorData?.factor_info?.total_payment
                                  )}
                                </>
                            ) : (
                                <>
                                  {!codeData
                                      ? factorData?.factor_info
                                          ?.total_payment &&
                                      numSeperator(
                                          Math.round(
                                              factorData?.factor_info
                                                  ?.total_payment
                                          )
                                      )
                                      : numSeperator(codeData.price)}
                                </>
                            )}
                            تومان</Typography>
                        </Box>
                        <hr className="text-white"/>
                        <FormControl>
                          <Box className="bg-light-gray p-4 fs-7 text-center rounded-lg mb-3" style={{opacity: 0.9}}>پرداخت از طریق</Box>
                          <RadioGroup
                              aria-labelledby="demo-radio-buttons-group-label"
                              defaultValue={(factorData?.factor_info?.wallet_remain > 0 && factorData?.factor_info?.wallet_remain !== 0 )? `wallet` : factorData?.factor_info?.payment_method !== 3 ? `cart` : `gateway`}
                              name="radio-buttons-group"
                          >
                            <Box className="d-flex flex-column">
                              <FormControlLabel value="wallet"
                                                onChange={(e)=>{setPaymentMethod(3)}} className="text-white fs-1 ms-0"
                                                control={<Radio className="text-white" />} label="کیف پول" />
                              <span className="ms-12 fs-8 gray-color">موجودی:
                                <span>
                                <b style={{ fontSize: '13px' }} className="ms-1" dir={`ltr`}>
                                  {factorData?.factor_info?.wallet_remain &&
                                      Number(
                                          factorData?.factor_info?.wallet_remain
                                      ).toLocaleString()}
                                </b>
                                <b
                                    style={{ fontSize: '13px' }}
                                    className={'ms-1'}
                                >
                                  تومان
                                </b>
                              </span>
                                </span>
                            </Box>

                            <FormControlLabel value="cart" checked={paymentMethod === 1}
                                              onChange={(e)=>{setPaymentMethod(1)}}
                                              className={`text-white fs-1 ms-0 ${factorData.factor_info.is_official !== 1 ? `d-block` : `d-none`}`}
                                              control={<Radio className="text-white" />}
                                              label="کارت به کارت" />
                            <FormControlLabel value="gateway" checked={paymentMethod === 0}
                                              onChange={(e)=>{setPaymentMethod(0)}}
                                              className={`text-white fs-1 ms-0 ${factorData.factor_info.is_official === 1 ? `d-block` : `d-none`}`}
                                              control={<Radio className="text-white" />}
                                              label="درگاه پرداخت" />
                          </RadioGroup>
                        </FormControl>
                      </div>
                      <LoadingButton
                          loadingBtn={loadingBtn}
                          onClick={payment}
                          custom_class={`bg-success w-100 mt-4 ${(paymentMethod === 0 || paymentMethod === 3) ? `d-block` : `d-none`}`}
                          title={paymentMethod === 0 ? 'پرداخت آنلاین' : 'پرداخت از کیف پول'}
                      />
                      <Box className={`bg-white rounded-lg shadow-sm p-4 mt-5 ${paymentMethod === 1 ? `d-block` : `d-none`}`}>
                          <div className="final-price relative p-4 d-flex justify-content-between">
                              <span className="text-muted">شماره کارت</span>
                              <span>
                                <b id="all_pay">{factorData.card_no}</b>
                              </span>
                          </div>

                          <div className="final-price relative p-4 d-flex justify-content-between">
                              <span className="text-muted">بانک</span>
                              <span>
                                <b id="all_pay">{factorData.account}</b>
                              </span>
                          </div>

                          <div className="final-price relative p-4 d-flex justify-content-between">
                              <span className="text-muted">به نام</span>
                              <span>
                                <b id="all_pay">{factorData.account_name}</b>
                              </span>
                          </div>
                      </Box>
                    </div>
                  </div>
              ) : (
                <Paper elevation={1} style={{ width: '100%', padding: '30px' }}>
                  <div
                    className={
                      'd-flex flex-column justify-content-center align-items-center'
                    }
                  >
                    <h1 className={'f-15 f-bold my-8'}>
                      فاکتور درخاستی یافت نشد
                    </h1>
                    <img
                      src="/assets/media/illustrations/unitedpalms-1/18.png"
                      width="100%"
                    ></img>
                  </div>
                </Paper>
              )}
            </>
          )}
        </>
      )}
      {
        <Alert
          alerts={alertStore.alert}
          close={alertStore.RemoveAlert}
          timeout={alert_timeout}
        />
      }
    </>
  );
};

export default FactorPayment;
